












































import Vue from 'vue'

export default Vue.extend({
  name: 'AppDialogConfirm',
  props: {
    message: {
      required: true,
      type: String
    }
  },
  computed: {
    slotHasContent (): boolean {
      return !!this.$slots.default && !!this.$slots.default[0]
    }
  }
})
